import { render, staticRenderFns } from "./webBQCms.vue?vue&type=template&id=42688725&scoped=true&"
import script from "./webBQCms.vue?vue&type=script&lang=js&"
export * from "./webBQCms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42688725",
  null
  
)

export default component.exports